import { useReactiveVar } from '@apollo/client';
import { ConnectedArrowsDoubleIcon } from '@synoptic/ui-kit/icons/react/connected-arrows-double.tsx';
import { DisconnectedArrowsArrowsIcon } from '@synoptic/ui-kit/icons/react/disconnected-arrows-arrows.tsx';
import { RefreshDoubleIcon } from '@synoptic/ui-kit/icons/react/refresh-double.tsx';
import { ConnectionStatusType } from '@/components/connection-status/connection-status-type.ts';
import { useNetworkStatus } from '@/components/network-status.ts';
import { websocketStatusVar } from '@/components/websocket-status-var.ts';

export const useConnectionStatus = (
  subscriptionStatus: ConnectionStatusType,
) => {
  const websocketStatus = useReactiveVar(websocketStatusVar);
  const { isOnline } = useNetworkStatus();

  if (
    isOnline &&
    websocketStatus === ConnectionStatusType.Connected &&
    subscriptionStatus === ConnectionStatusType.Connected
  ) {
    return {
      icon: ConnectedArrowsDoubleIcon,
      label: 'connected',
      status: ConnectionStatusType.Connected,
    };
  }

  if (
    websocketStatus === ConnectionStatusType.Disconnected ||
    subscriptionStatus === ConnectionStatusType.Disconnected
  ) {
    return {
      icon: DisconnectedArrowsArrowsIcon,
      label: 'disconnected',
      status: ConnectionStatusType.Disconnected,
    };
  }

  return {
    icon: RefreshDoubleIcon,
    label: 'connecting',
    status: ConnectionStatusType.Connecting,
  };
};
